<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <!-- <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2">Cargar Foto</vs-button>
        <vs-button type="border" color="danger">Eliminar</vs-button>
        <p class="text-sm mt-2">Formatos: JPG, GIF or PNG. Tamaño máximo: 1Mb</p>
      </div>
    </div> -->

    <!-- Ajustes Generales -->
    <div class="vx-row">
      <div class="vx-col">
        <h5>Ajustes Generales</h5>
      </div>
    </div>

    <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
      <span>Tu cuenta no está confirmada <a href="#" class="hover:underline">Reenviar Confirmación</a></span>
    </vs-alert>
    
    <!--  -->
    <div class="vx-row">
      <div class="vx-col w-full">
            <vs-input class="w-2/3 my-base " label-placeholder="Nombre de la Clínica" v-model="company"></vs-input>
             <!-- Firma -->
            <vs-textarea label="Pie de Receta" v-model="bio" placeholder="Pie de Receta" />
      </div>
    </div>

    <!-- <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h4>Configuración de Caja</h4>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col w-full">
        <h6>Métodos de Pago</h6>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row flex justify-center py-3">
          <v-select class="w-2/5" placeholder="Método de pago" taggable 
            :options="['Tarjeta', 'Efectivo', 'Visanet', 'Credomatic']" 
            :dir="$vs.rtl ? 'rtl' : 'ltr'" 
          />
          <vs-button class="mx-2" color="success" type="filled" icon-pack="feather" icon="icon-plus">
            Agregar
          </vs-button>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h6>Condiguración de Moneda</h6>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row flex justify-center py-3">
          <vs-input label-placeholder="Nombre" class="mr-3" v-model="value1"/>
          <vs-input label-placeholder="Símbolo" class="ml-3" v-model="value2"/>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h6>IVA</h6>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row flex justify-center py-3">
          <vs-input label-placeholder="Porcentaje" class="mr-3" v-model="value3"/>
          <vs-checkbox class="mt-4" icon-pack="feather" icon="icon-check" color="success" v-model="checkBox1">
            Sumar al valor final de la consulta
          </vs-checkbox>
        </div>
      </div>
    </div> -->

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Guardar Cambios</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      username: 'johny_01',
      name: this.$store.state.AppActiveUser.displayName,
      email: 'john@evolugy.com',
      company: 'Evolugy'
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
